import React, { useState } from 'react'
import i18n from 'i18next'
import { observer } from 'mobx-react'
import Button from '../../UniformComponents/Button'
import Modal from '../../UniformComponents/Modal'
import Typography from '../../UniformComponents/Typography'
import Checkbox from '../form/Checkbox'

const SetParentSurveyModal = (props) => {
    const [copyStyling, setCopyStyling] = useState(true)
    const {
        store, showSetParentSurveyModal, toggleSetParentSurveyModal, noOfResponses,
    } = props

    const { addNewParentSurvey, toggleIsParent } = store

    const createParent = async () => {
        const newParentId = await addNewParentSurvey(copyStyling)
        store.store.goTo('setup', undefined, newParentId)
    }

    const toggleParent = async () => {
        await toggleIsParent()
        toggleSetParentSurveyModal()
    }

    return (
        <Modal show={showSetParentSurveyModal} onClose={toggleSetParentSurveyModal}>
            <div className="uc-modal__header" style={{ textAlign: 'left' }}>
                <Typography type="h2" style={{ marginBottom: '24px' }}>
                    {noOfResponses
                        ? i18n.t('setParentSurveyModal.response.title')
                        : i18n.t('setParentSurveyModal.noResponse.title')}
                </Typography>
                <Typography type="p">
                    {noOfResponses
                        ? i18n.t('setParentSurveyModal.response.subtitle')
                        : i18n.t('setParentSurveyModal.noResponse.subtitle')}
                </Typography>
            </div>
            <div
                style={{
                    display: 'flex', flexDirection: 'column', gap: '16px',
                }}
                className="addSurveyBranchForm"
            >
                <div style={{ marginTop: '8px' }}>
                    {noOfResponses ? (
                        <Checkbox
                            name="copyStyling"
                            label={i18n.t('copyStyling')}
                            checked={copyStyling}
                            onBlur={({ value }) => setCopyStyling(value)}
                        />
                    ) : null}
                </div>
                <div className="uc-modal__button-panel" style={{ justifyContent: 'space-between' }}>
                    <div style={{
                        backgroundColor: '#E8FCFA',
                        border: '1px solid #33E1D5',
                        borderRadius: '8px',
                        width: '100%',
                        padding: '16px',
                    }}
                    >
                        <Typography type="h3">
                            {noOfResponses
                                ? i18n.t('setParentSurveyModal.response.controls')
                                : i18n.t('setParentSurveyModal.noResponse.controls')}
                        </Typography>
                        <div style={{
                            display: 'flex', gap: '16px', marginTop: '16px',
                        }}
                        >
                            <Button
                                cssClass="regular"
                                variant="tertiary"
                                label={i18n.t('gen_no')}
                                onClick={toggleSetParentSurveyModal}
                            />
                            <Button
                                cssClass="regular"
                                variant="secondary"
                                label={i18n.t('gen_yes')}
                                onClick={noOfResponses ? createParent : toggleParent}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    )
}

export default observer(SetParentSurveyModal)
